import React from "react";
import { BrowserRouter as Router, Routes, Route } from "react-router-dom";
import { ThemeProvider } from "@material-tailwind/react";

// Importação de Páginas e Componentes
import Comercial from "./Pages/Comercial";
import Navbar from "./componentes/Navbar/Navbar";
import BacklogVendas from "./Pages/BacklogVendas";
import FormsWarmupComercial from "./componentes/Formulario/FormsWarmupComercial";
import AuthRedirect from "./Pages/RedirectAuth";
import Login from "./Pages/Login";
import { AuthProvider } from "./componentes/Auth/AuthContext/AuthContext";
import HomeDashboard from "./Pages/HomeDashboard";
import Home from "./Pages/home";
import FormsWarmupProjetos from "./componentes/Formulario/FormsWarmupProjetos";
import WarmupProjetos from "./componentes/WarmupProjetos/WarmupProjetos";
import Projetos from "./Pages/Projetos";
import DashboardComercial from "./componentes/DashboardComercial/DashboardComercial";
import DashboardProjetos from "./componentes/DashboardProjetos/DashboardProjetos";
import WarmupComercial from "./componentes/WarmupComercial/WarmupComercial";
import Financeiro from "./Pages/Financeiro";
import WarmupFinanceiro from "./componentes/WarmupFinanceiro/WarmupFinanceiro";
import FormsWarmupFinanceiro from "./componentes/Formulario/FormsWarmupFinanceiro";
import ProtectedRoute from "./componentes/Auth/ProtectedRoute/ProtectedRoute";
import ControleProjetos from "./componentes/ControleProjetos/ControleProjetos";
import ControleProjetosFinanceiro from "./componentes/ControleProjetosFinanceiro/ControleProjetosFinanceiro";

function App() {
  return (
    <AuthProvider>
      <ThemeProvider>
        <Router>
          <div className="flex flex-col h-screen overflow-hidden">
            <Navbar />
            <main className="flex-grow overflow-auto custom-scrollbar">
              <Routes>
                <Route path="/" element={<Home />} />
                <Route path="/auth/login" element={<Login />} />
                <Route path="/auth/redirect" element={<AuthRedirect />} />

                {/* Rotas Protegidas */}
                <Route
                  path="/dashboard"
                  element={
                    <ProtectedRoute groupId={'df5919f9-37fd-4725-9aab-8ecc154789a8'}>
                      <HomeDashboard />
                    </ProtectedRoute>
                  }
                />
                <Route
                  path="/comercial"
                  element={
                    <ProtectedRoute groupId="df5919f9-37fd-4725-9aab-8ecc154789a8" channelId={'19:b3da72357c7b499094aa6313bc5b37a5@thread.tacv2'}>
                      <Comercial />
                    </ProtectedRoute>
                  }
                >
                  <Route path="dashboard" element={<DashboardComercial />} />
                  <Route path="backlog-vendas" element={<BacklogVendas />} />
                  <Route path="warmup" element={<WarmupComercial />} />
                </Route>
                <Route
                  path="/projetos"
                  element={
                    <ProtectedRoute groupId="df5919f9-37fd-4725-9aab-8ecc154789a8" channelId={'19:f826e90af9f741319cf021cf04aa19a4@thread.tacv2'}>
                      <Projetos />
                    </ProtectedRoute>
                  }
                >
                  <Route path="dashboard" element={<DashboardProjetos />} />
                  <Route path="warmup" element={<WarmupProjetos />} />
                  <Route path="lista" element={<ControleProjetos />} />
                </Route>
                <Route
                  path="/financeiro"
                  element={
                    <ProtectedRoute groupId="df5919f9-37fd-4725-9aab-8ecc154789a8" channelId={'19:6322f957e1884aa595b0e10e6a5b11c8@thread.tacv2'}>
                      <Financeiro />
                    </ProtectedRoute>
                  }
                >
                  <Route path="dashboard" element={<div>Dashboard Financeiro</div>} />
                  <Route path="warmup" element={<WarmupFinanceiro />} />
                  <Route path="projetos" element={<ControleProjetosFinanceiro />} />

                </Route>
                <Route
                  path="/forms-warmup-comercial/:id"
                  element={
                    <ProtectedRoute groupId="df5919f9-37fd-4725-9aab-8ecc154789a8" channelId={'19:b3da72357c7b499094aa6313bc5b37a5@thread.tacv2'}>
                      <FormsWarmupComercial />
                    </ProtectedRoute>
                  }
                />
                <Route
                  path="/forms-warmup-projetos/:id"
                  element={
                    <ProtectedRoute groupId="df5919f9-37fd-4725-9aab-8ecc154789a8" channelId={'19:f826e90af9f741319cf021cf04aa19a4@thread.tacv2'}>
                      <FormsWarmupProjetos />
                    </ProtectedRoute>
                  }
                />
              </Routes>
            </main>
          </div>
        </Router>
      </ThemeProvider>
    </AuthProvider>
  );
}

export default App;
